import {
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tag as ANTDTag,
  Typography,
} from 'antd';

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getAllCollaborators } from '../../api/constlink';
import { phoneFormatter } from '../../util/utils';

const { Text } = Typography;
const StyledDiv = styled.div``;

const columns = [
  {
    title: '회사명',
    dataIndex: ['application', 'general', 'name'],
    width: '20%',
  },
  {
    title: '대표명',
    dataIndex: ['application', 'general', 'representativeName'],
    width: '10%',
  },
  {
    title: '주력공종',
    dataIndex: ['application', 'general', 'type3'],
    width: '20%',
  },
  {
    title: '보유면허',
    dataIndex: ['application', 'general', 'type2'],
    width: '20%',
    render: (value: any, record: any, index: number) => {
      return (
        <>
          {value === undefined
            ? null
            : value.map((tag: any, index: any) => (
                <ANTDTag key={index}>{tag}</ANTDTag>
              ))}
        </>
      );
    },
  },
  {
    title: '담당자',
    dataIndex: ['application', 'contactPoint'],
    width: '20%',
    render: (value: any, record: any, index: number) => (
      <>
        <Space direction="vertical">
          <span>
            {value.name === undefined ? null : value.name}
            {value.personalPhoneNumber === undefined
              ? null
              : `(${phoneFormatter(value.personalPhoneNumber, 1)})`}
          </span>
          <span></span>
          <span>{value.email === undefined ? null : value.email}</span>
        </Space>
      </>
    ),
  },
  {
    title: '비고',
    dataIndex: 'disabledReason',
    width: '20%',
    render: (value: any, record: any, index: number) => {
      return (
        <>{value === undefined ? null : <Text type="danger">{value}</Text>}</>
      );
    },
  },
];

interface SearchBiddersModal2Props {
  visible: boolean;
  enterpriseId: string;
  projectId: string;
  existingCollaborators: any[];
  type3ChoiceData: any;
  onCreate: (userIdList: number[]) => void;
  onCancel: () => void;
}

function SearchBiddersModal2({
  visible,
  enterpriseId,
  projectId,
  existingCollaborators,
  type3ChoiceData,
  onCreate,
  onCancel,
}: SearchBiddersModal2Props) {
  const [form] = Form.useForm();
  const [type3Choices, setType3Choices] = useState<any>();
  const [users, setUsers] = useState<any[]>([]);
  const [collaborators, setCollaborators] = useState<any[]>([]);
  const [selectedRowKeysLocal, setSelectedRowKeysLocal] = useState<React.Key[]>(
    [],
  );

  useEffect(() => {
    if (type3ChoiceData === undefined) return;
    const subcontractTypeList = [];
    const materialTypeList = [];
    for (const val of type3ChoiceData.subcontractTypeChoiceList) {
      subcontractTypeList.push({
        label: `${val}`,
        value: `${val}`,
      });
    }
    for (const val of type3ChoiceData.materialTypeChoiceList) {
      materialTypeList.push({
        label: `${val}`,
        value: `${val}`,
      });
    }
    setType3Choices({ subcontractTypeList, materialTypeList });
  }, [type3ChoiceData]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setUsers([...selectedRows]);
      setSelectedRowKeysLocal(selectedRowKeys);
    },
    selectedRowKeys: selectedRowKeysLocal,
    getCheckboxProps: (record: any) => ({
      disabled: record.disabled,
    }),
  };

  const _getCollaboratorList = async (formData: any) => {
    const data: any[] = await getAllCollaborators(enterpriseId, {
      ...formData,
    });
    for (const collaborator of data) {
      let disabled = false;
      for (const existingCollaborator of existingCollaborators) {
        if (existingCollaborator.vendor.id === collaborator.id) {
          disabled = true;
          collaborator.disabledReason = '등록불가(이미 추가된 업체)';
        }
        if (collaborator.application.contactPoint.email === undefined) {
          disabled = true;
          collaborator.disabledReason = '등록불가(담당자 이메일 정보 없음)';
        }
      }
      collaborator.disabled = disabled;
    }
    setCollaborators(data);
  };

  return (
    <StyledDiv>
      <Modal
        visible={visible}
        title="업체검색"
        okText="확인"
        cancelText="취소"
        width={1100}
        onCancel={onCancel}
        onOk={() => {
          const _userIdList: number[] = [];
          for (const user of users) {
            _userIdList.push(user.id);
          }
          onCreate(_userIdList);
        }}
      >
        {type3Choices && (
          <Form form={form} onFinish={_getCollaboratorList} initialValues={{}}>
            <Row>
              <Col span={11}>
                <Form.Item name="type3" label="주력공종">
                  <Select
                    style={{ width: '100%' }}
                    onSelect={(value: any) =>
                      _getCollaboratorList({
                        type3: value,
                        qualificationStatus: '2',
                      })
                    }
                    options={[
                      {
                        label: '시공',
                        options: [...type3Choices.subcontractTypeList],
                      },
                      {
                        label: '자재',
                        options: [...type3Choices.materialTypeList],
                      },
                    ]}
                  ></Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        <Table
          rowKey="id"
          size="small"
          columns={columns}
          rowSelection={{ ...rowSelection, checkStrictly: false }}
          dataSource={collaborators}
        />
      </Modal>
    </StyledDiv>
  );
}

export default SearchBiddersModal2;
